<template src="./index.html"></template>

<script>
import { mapState } from "vuex";
export default {
    name: 'ManualHelp',
    computed: {
        ...mapState({
            ManualHelp: (state) => {
                return state.Public.ManualHelp;
            },
        }),
    },
    data() {
        return {
            contactDivShow: true,
            contactImg: false,
            popupShow: false,
            defferScroll: function (event) {
                event.preventDefault()
            },
            pageName: sessionStorage.getItem('pageName')
        }
    },
    methods: {
        clickBtn(index) {
            this.$store.commit("Public/SET_DATA", {
                key: "ManualHelp",
                data: {
                    contactDivShow: !this.ManualHelp.contactDivShow,
                    contactImg: !this.ManualHelp.contactImg
                },
            });
            if(index == 0) {
                this.$store.dispatch("Public/inH5Record", {
                    btn_name: "人工协助",
                    page_param: { pageName: this.pageName },
                });
            }
        },
        useClass() {
            this.$router.push({name:"ImgTextPage"});
            this.$store.dispatch("Public/inH5Record", {
                btn_name: "使用教程",
                page_param: { pageName: this.pageName },
            });
        },
        contactBtn() {
            this.popupShow = true
            document.body.addEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.addEventListener("wheel", this.defferScroll, {passive: false});
            this.$store.dispatch("Public/inH5Record", {
                btn_name: "联系人工",
                page_param: { pageName: this.pageName },
            });
        },
        closeBtn() {
            this.popupShow = false
            document.body.removeEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.removeEventListener("wheel", this.defferScroll, {passive: false});
        }
    }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>